<template>
  <div>
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-start">
      <Lynx-Title
        :text="
          'Gerenciamento de ' +
          (tipo == 'notafiscal' ? 'Nota Fiscal' : ' Recalculo')
        "
      />

      <div class="flex flex-row-reverse items-end mb-4">
        <b-button
          class="is-primary ml-4"
          icon-right="refresh"
          @click.native="() => fetchGerais()"
          >Atualizar Lista
        </b-button>
        <!-- <b-button class="is-primary ml-4" icon-right="email-send" @click.native="handleEnvioTodas">Enviar Agora
        </b-button> -->
      </div>
    </div>

    <div class="w-full flex justify-between">
      <div class="flex justify-start w-2/3 gap-2">
        <label class="pb-4">
          <Lynx-Label label="Competência" />
          <b-datepicker
            type="month"
            placeholder="Selecione a data de competência"
            icon="calendar-today"
            :month-names="monthNames"
            v-model="dataCompetencia"
          />
        </label>
        <label class=" w-2/4   ">
          <Lynx-Label label="Carteiras" class=" " />
          <b-select
          placeholder="Selecione as carteiras..."
          name="form-class"
           
            v-model="carteira"
          >
          <!-- <option selected disabled>Selecione as carteiras...</option> -->

            <option value="">Todos</option>
            <option
              v-for="item in lista_carteiras"
              :key="item.id"
              :value="item.label"
            >
              {{ item.label }}
            </option>
          </b-select>
        </label>

        <!-- <label class="pb-4 ml-4">
          <Lynx-Label label="Data de Envio"/>
          <b-datepicker
            placeholder="Selecione a data de envio"
            icon="calendar-today"
            :month-names="monthNames"
            v-model="dataEnvio"
            @input="fetchGerais"
          />
        </label> -->

        <!-- <b-field label="Status" class="ml-4">
          <b-select placeholder="Selecione um status" v-model="filter_status">
            <option
              v-for="item in status_gerais"
              :value="item.id"
              :key="item.id">
              {{ item.status }}
            </option>
          </b-select>
        </b-field> -->

        <!-- <b-field class="ml-4" label="Carteira">
          <b-select placeholder="Selecione uma carteira" v-model="carteira_filter">
            <option
              label="Todas"
              value="todas"
            />
            <option
              label="Sem carteira"
              value="sem_carteira"
            />
            <option
              v-for="item in carteiras"
              v-text="item.nome"
              :value="item.id"
              :key="item.id"
            />
          </b-select>
        </b-field> -->
      </div>

      <div class="flex flex-row-reverse items-end mb-4 w-1/3">
        <div class="control ml-4">
          <b-taglist attached>
            <b-tag type="is-primary" size="is-medium">Processando:</b-tag>
            <b-tag type="is-warning" size="is-medium">{{
              uploadReport.total || "..."
            }}</b-tag>
          </b-taglist>
        </div>
        <div class="control">
          <b-taglist attached>
            <b-tag type="is-primary" size="is-medium">Erros:</b-tag>
            <b-tag type="is-danger" size="is-medium">{{
              uploadReport.withError || "..."
            }}</b-tag>
          </b-taglist>
        </div>
      </div>
    </div>

    <b-table
      :data="geraisComputed"
      :columns="columns"
      :paginated="true"
      default-sort-direction="asc"
      default-sort="id"
      per-page="10"
      class="w-full responsive"
      style="font-size: 12px;"
    
    >
      <template slot-scope="props">
        <b-table-column style="width: 10px;" field="id" v-text="props.row.empresas_id" />
        <b-table-column field="tipo">
          {{ props.row.tipo.replace("_", " ") }}
        </b-table-column>
        <b-table-column field="Criação">{{
          props.row.created_at | formatEnToBr
        }}</b-table-column>
        <b-table-column field="Emissão">
          {{ props.row.emissao | formatEnToBr }}</b-table-column
        >
        <b-table-column field="Motico Cancelamento">
          {{ props.row.motivo_cancelado }}</b-table-column
        >

        <b-table-column field="Criou">
           <span v-if="props.row.in"> {{ props.row.in.nome_completo }}</span>
            </b-table-column>
            <b-table-column field="Atualizou">
           <span v-if="props.row.up"> {{ props.row.up.nome_completo }}</span>
            </b-table-column>
            <b-table-column field="Deletou">
           <span v-if="props.row.del"> {{ props.row.del.nome_completo }}</span>
            </b-table-column>

        <b-table-column field="acoes">
          <div class="flex justify-wrap">
            <Lynx-Button
              icon="Eye"
              icon-size="4"
              size="small"
              @click.native="openFile(props.row.arquivo.id)"
            />
            <Lynx-Button
            v-show="!props.row.data_estorno"
              icon="Trash"
              color="error-base"
              icon-size="4"
              size="small"
              @click.native="showModalDelete(props.row.id)"
            />
          </div>
        </b-table-column>
      </template>
    </b-table>

    <b-modal :active.sync="modaldelete">
      <v-card elevation="10" height="220px" class="p-3">
        <Lynx-Title text="Motivo Cancelar" />

        <Lynx-Textarea
          placeholder="Digite o motivo para cancelar"
          v-model="form.motivo_cancelado"
        />
        <div class="w-full flex justify-end items-start">
          <Lynx-Button
            icon="Trash"
            color="error-base"
            icon-size="4"
            size="small"
            :disabled="!form.motivo_cancelado"
            @click.native="deleteGerais()"
          />
        </div>
      </v-card>
    </b-modal>
    <!-- <b-modal :active.sync="guiasModal" @close="closeGeraisModal" v-if="guiasModal">
      <GerenciamentoGeraisDetails :current-empresa="currentEmpresa" @estornar="fetchGerais"/>
    </b-modal> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  geraisRequest,
  getUploadReport,
  geraisDeleteRequest,
} from "@/services/requests/gerais";
import { formatBrToEn, formatDateTimeToBr } from "@/utils/momentHelpers";
import { monthNames } from "@/utils/utils";
// import GerenciamentoGeraisDetails from '@/views/guias/GerenciamentoGeraisDetails'
import { hasPermission } from "@/utils/can";
import { carteirasRequest } from "../../services/requests/carteiras";
import { formatEnToBr } from "@/utils/momentHelpers";
import LynxTextarea from "@/components/helpers/Textarea";

export default {
  name: "GerenciamentoGerais",
  props: ["tipo"],
  components: { LynxTextarea },

  data() {
    return {
      modaldelete: false,
      form: {
        motivo_cancelado: null,
        gerais_id: null,
        usuario_id: null,
      },
      monthNames,
      dataCompetencia: null,
      dataEnvio: null,
      loading: false,
      carteiras: [],
      carteira_filter: "todas",
      carteira:null,
      columns: [
        {
          field: "empresas_id",
          label: "Empresa",
          searchable: true,
          sortable: true,
        },
        {
          field: "tipo",
          label: "Tipo",
        },

        {
          field: "created_at",
          label: "Criação",
        },
        {
          field: "emissao",
          label: "Emissão",
        },
        {
          field: "motivo_cancelado",
          label: "Motivo Cancelamento",
        },
        {
          field: "in",
          label: "Criou",
        },
        {
          field: "up",
          label: "Atualizou",
        },
        {
          field: "del",
          label: "Deletou",
        },
        {
          label: "acoes",
        },
      ],
      gerais: [],
      currentGerais: {},
      guiasModal: false,
      filter_status: null,
      uploadReport: {},
      uploadReportInterval: null,
      status_gerais: [
        { id: 0, status: "Todas" },
        { id: 1, status: "Enviado" },
        { id: 6, status: "Não enviado" },
        { id: 2, status: "Com Erro" },
        { id: 3, status: "Pendente Financeiro" },
        { id: 4, status: "Pendente RH" },
        { id: 5, status: "Pendente Contabilidade" },
      ],
    };
  },
  filters: {
    formatEnToBr,
  },
  computed: {
    
    ...mapGetters(["getCompetenciaDate", "getUser"]),
    lista_carteiras() {
      //  return this.$store.state.carteira.lista_carteiras;

      let carteira = Object.values(this.$store.state.carteira.lista_carteiras);
      let data = [];
      for (let i = 0; i < carteira.length; i++) {
        if (carteira[i].setor == "contabilidade") {
          data.push({ id: carteira[i].id, label: carteira[i].nome });
        }
      }
      return data;
    },
    dataCompetenciaComputed() {
      return this.dataCompetencia
        ? formatBrToEn(this.dataCompetencia)
        : this.getCompetenciaDate;
    },

    geraisComputed() {
      const filteredItems = this.gerais.filter((item) => {
  const tipoMatch = item.tipo.replace("_", "").toLowerCase() === this.tipo;
  const carteiraMatch =
    this.carteira === null || String(item.carteiras).includes(String(this.carteira)) 
  const dataCompetenciaMatch =
    this.dataCompetencia === null ||
    formatEnToBr(item.data_competencia) === formatEnToBr(this.dataCompetencia);

  return tipoMatch && carteiraMatch && dataCompetenciaMatch;
});


         
return filteredItems;
    },
  },

  mounted() {
    // this.fetchCarteiras()
    this.fetchGerais();
    this.listar_carteiras();
    console.log("Valor do parâmetro recalculo:", this.tipo);
    // this.fetchUploadReport()
    // this.uploadReportInterval = setInterval(() => this.fetchUploadReport(), 15000)
  },
  destroyed() {
    clearInterval(this.uploadReportInterval);
  },
  methods: {
    hasPermission,
    fetchCarteiras() {
      carteirasRequest()
        .then((response) => {
          const { data } = response.data;
          this.carteiras = data.filter(
            (carteira) => carteira.setor === "contabilidade"
          );
        })
        .catch((error) => this.$snack.error(error.response.data.message));
    },
    fetchUploadReport() {
      getUploadReport()
        .then((response) => (this.uploadReport = response.data))
        .catch(() => this.$snack.error("Erro ao calcular Uploads pendentes."));
    },
    fetchGerais() {
      this.loading = true;

      geraisRequest()
        .then((res) => (this.gerais = res.data))
        .catch(() =>
          this.$snack.error("Ocorreu um erro, tente novamente mais tarde")
        )
        .finally(() => (this.loading = false));
    },
    showModalDelete(id) {
      this.modaldelete = true;
      this.form.gerais_id = id;
      this.form.usuario_id = this.getUser.id;
    },
    async deleteGerais() {
      this.loading = true;

      await geraisDeleteRequest(this.form)
        .then((res) => this.$snack.error(res.data.message))
        .catch(() =>
          this.$snack.error("Ocorreu um erro, tente novamente mais tarde")
        )
        .finally(() => (this.loading = false));

        this.gerais = this.gerais.map((geral) => {
  if (geral.id === this.form.gerais_id) {
    geral.motivo_cancelado = this.form.motivo_cancelado;
    geral.usuario_id = this.form.usuario_id;
  }
  return geral;
});
    },
    openFile(fileId) {
      window.open(
        `${process.env.VUE_APP_API_URL}/arquivos/${fileId}/open?token=${this.$store.getters.getToken}`
      );
    },

    rel(value) {
      window.open(
        "https://api.medcontabil.com.br/relatorio/fechamento-mensal?empresa_id=" +
          value,
        "_brank"
      );
    },
    listar_carteiras() {
      this.$store.dispatch("carteira/listar_carteiras");
    },
  },
};
</script>
